import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import logo from "../images/logo.svg";
import config from "../config"; 

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://senu-app.azurewebsites.net/api/users/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Login successful:" );
        navigate("/loading"); // Redirect after successful login
// Save the full object including token
localStorage.setItem(
  "userData",
  JSON.stringify({
    ...data.user,              // everything about the user
    token: data.token,         // auth token from backend
    licenseKey: data.userLicenseKey // keep licenseKey too
  })
);




      } else {
        const errorData = await response.json();
        setError(errorData.message || "Login failed");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <img src={logo} alt="Senu Logo" className="login-logo" />
      <h2 className="login-title">Welcome Back</h2>

      <form className="login-form" onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          className="login-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          className="login-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="login-button">Log In</button>
      </form>

      <p className="signup-text">
        Don’t have an account? <Link to="/signup">Sign Up</Link>
      </p>
      <p className="forgot-text">
        <Link to="/forgot-password">Forgot Password?</Link>
      </p>
      <p className="admin-login-text">
        Are you a security admin? <Link to="/admin-login">Admin Login</Link>
      </p>

    </div>
  );
}
